import { render } from "./ServicesComponent.vue?vue&type=template&id=2e3a05bb&scoped=true"
import script from "./ServicesComponent.vue?vue&type=script&lang=js"
export * from "./ServicesComponent.vue?vue&type=script&lang=js"

import "./ServicesComponent.vue?vue&type=style&index=0&id=2e3a05bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3a05bb"]])

export default __exports__